var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.1875C7.85595 1.1875 6.24881 1.67502 4.88183 2.58841C3.51484 3.5018 2.44941 4.80003 1.82026 6.31894C1.1911 7.83785 1.02649 9.50922 1.34723 11.1217C1.66797 12.7342 2.45965 14.2153 3.62218 15.3778C4.7847 16.5403 6.26585 17.332 7.87832 17.6528C9.49078 17.9735 11.1621 17.8089 12.6811 17.1797C14.2 16.5506 15.4982 15.4852 16.4116 14.1182C17.325 12.7512 17.8125 11.1441 17.8125 9.5C17.8125 7.29539 16.9367 5.18107 15.3778 3.62217C13.8189 2.06328 11.7046 1.1875 9.5 1.1875ZM8.3125 12.8195L5.34375 9.85079L6.28817 8.90625L8.3125 10.9305L12.7122 6.53125L13.6596 7.47288L8.3125 12.8195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCard);
export default __webpack_public_path__ + "static/media/ic-check-card.aa165e706062c349d054ef6d3696225a.svg";
export { ForwardRef as ReactComponent };